module.exports = __webpack_public_path__ + "img/mydessk-reduce.39551387.svg";